import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import store from './store';
import Pusher from 'pusher-js';
import axios from 'axios';
import router from './router'
import {i18n} from './plugins/i18n';
import VueMeta from 'vue-meta';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueGeolocation from 'vue-browser-geolocation';
import './registerServiceWorker'
import { authService } from '@/services/authService';

// <scs-admin-menus> and friends are custom elements defined by the AdminAuth UI
// bundle, not Vue components.
Vue.config.ignoredElements = [/^scs-/];

Vue.use(VueMeta);
Vue.use(VueGeolocation);
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    installComponents: true,
    libraries: 'places'
  }
});
Vue.prototype.$pusher = new Pusher('310e1277542af485e1b6', {
  cluster: 'eu',
  forceTLS: true
});

if (process.env.NODE_ENV === 'development') {
  Vue.config.devtools = true;
}



axios.defaults.baseURL = process.env.VUE_APP_API_URL;
Vue.config.productionTip = false;

// Public paths that must never be hijacked by SSO
const PUBLIC_PATHS = [
  '/account-registration',
  '/space-join',
  '/account-password-update',
  '/account-password-reset',
  '/forgot-password',
  '/change-password',
  '/update-account',
];

// Resolve any existing Guards session before mounting, so the router guard sees
// a token instead of bouncing the user to /login.
(async () => {
  try {
    const currentPath = window.location.pathname;
    const isPublicPage = PUBLIC_PATHS.some(p => currentPath.startsWith(p));

    // Never attempt SSO on public pages (register, invite, forgot-password, etc.)
    if (!isPublicPage) {
      const logoutFlag = sessionStorage.getItem('logout');
      const isOwnLogin = localStorage.getItem('isOwnLogin');

      if (!logoutFlag && !isOwnLogin) {
        const urlParams = new URLSearchParams(window.location.search);
        // Keycloak may return the auth code either in the query string
        // (response_mode=query) or in the hash fragment (response_mode=fragment).
        // The hash on a Vue hash-mode app starts with `#/...`; the Keycloak
        // fragment instead looks like `#state=...&code=...`, so strip a single
        // leading '#' before parsing.
        const rawHash = window.location.hash.startsWith('#')
          ? window.location.hash.slice(1)
          : window.location.hash;
        const hashParams = new URLSearchParams(rawHash.startsWith('/') ? '' : rawHash);
        const isKeycloakCallback =
          (urlParams.has('code') && urlParams.has('session_state')) ||
          (hashParams.has('code') && hashParams.has('session_state'));
        // If arriving from a 7platform/NSoft app the user already has a Keycloak
        // session — iframe check-sso is unreliable due to third-party cookie blocking,
        // so we use authService.initialize() which falls back to a full redirect when
        // needed (Keycloak sees the session and returns immediately).
        const isNsoftReferrer = !!document.referrer &&
          (document.referrer.includes('7platform.net') || document.referrer.includes('nsoft.cloud'));

        // Only trigger full AdminAuth init for explicit Keycloak callbacks or known
        // NSoft referrers. Never auto-redirect just because admin_token exists —
        // that caused an unwanted redirect whenever the Keycloak session had expired.
        if (isKeycloakCallback || isNsoftReferrer) {
          // Full AdminAuth init: silently refreshes if session exists, or redirects
          // to Keycloak (which auto-authenticates and returns) if iframe check fails.
          await authService.initialize();
        } else if (currentPath !== '/login') {
          // No previous Guards session and no known SSO referrer —
          // iframe-only silent check, never redirects (safe for email/password users).
          // Skip on /login: visiting the sign-in page should never auto-trigger
          // a token exchange. Cross-app SSO still works via the isNsoftReferrer
          // branch above.
          const ssoSuccess = await authService.silentSsoCheck();
          if (ssoSuccess) {
            // Session confirmed via iframe — now also initialize AdminAuth so
            // adminAuthInstance has a valid state for <scs-admin-menus>.
            // Session is already established so this will not redirect.
            await authService.initialize();
          }
        }
      }
    }
  } catch (e) {
    console.warn('Auth initialization failed:', e);
  }

  i18n.locale = store.state.lang;
  new Vue({
    i18n,
    vuetify,
    store,
    router,
    render: h => h(App)
  }).$mount('#app');
})();
